import React, { useState } from "react";
import {
	Button,
	Dropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
	Table,
	Modal,
	ModalHeader,
	ModalBody,
	ModalFooter,
} from "reactstrap";
import "./styles.css";
import { cqrs } from "../cqrs.js";
import { useReactOidc } from "@axa-fr/react-oidc-context";

function ResourceDetail({ resource }) {
	const { oidcUser } = useReactOidc();
	const [optionsOpen, setOptionsOpen] = useState(false);
	const [restartResourceModalOpen, setRestartResourceModalOpen] =
		useState(false);
	const [errorModalOpen, setErrorModalOpen] = useState(false);
	const [errorMessage, setErrorMessage] = useState("wololo");

	const toggleOptions = () => setOptionsOpen((prevState) => !prevState);
	const toggleRestartResourceModal = () =>
		setRestartResourceModalOpen((prevState) => !prevState);
	const toggleErrorModal = () => setErrorModalOpen((prevState) => !prevState);

	const onRestartEnvironment = () => {
		cqrs(
			"/api/resource/restart",
			{ Id: resource.resourceId },
			oidcUser.id_token
		).then((response) => {
			if (response.status != 200) {
				response
					.text()
					.then((val) =>
						setErrorMessage(val.substring(1, val.length - 1))
					);
				if (response.status == 404) {
					setErrorMessage("404; Endpoint not found.");
				}
				toggleErrorModal();
			}
		});
	};

	return (
		<>
			<tr>
				<th>
					{new Date().getTime() >= new Date(resource.stopAt).getTime()
						? "🔴"
						: "🟢"}
				</th>
				<th scope="row">{resource.resourceName}</th>
				<th>
					{new Date(resource.stopAt).toLocaleTimeString("no-NO", {
						hour12: false,
						hour: "2-digit",
						minute: "2-digit",
						second: "2-digit",
						timeZoneName: "short",
					}) +
						" - " +
						new Date(resource.stopAt).toLocaleDateString("no-NO", {
							dateStyle: "short",
						})}
				</th>
				<th>
					<Dropdown isOpen={optionsOpen} toggle={toggleOptions}>
						<DropdownToggle>🛠</DropdownToggle>
						<DropdownMenu>
							<DropdownItem onClick={toggleRestartResourceModal}>
								Restart Resource
							</DropdownItem>
						</DropdownMenu>
					</Dropdown>
				</th>
			</tr>
			<Modal
				isOpen={restartResourceModalOpen}
				toggle={toggleRestartResourceModal}
			>
				<ModalHeader toggle={toggleRestartResourceModal}>
					Restart {resource.resourceName}
				</ModalHeader>
				<ModalBody>
					Are you sure you want to restart {resource.resourceName}?
					(This action will be logged.)
				</ModalBody>
				<ModalFooter>
					<Button
						color="primary"
						onClick={(e) => {
							onRestartEnvironment();
							toggleRestartResourceModal();
						}}
					>
						Yes, restart.
					</Button>{" "}
					<Button
						color="secondary"
						onClick={toggleRestartResourceModal}
					>
						Nope, abort.
					</Button>
				</ModalFooter>
			</Modal>
			<Modal isOpen={errorModalOpen} toggle={toggleErrorModal}>
				<ModalHeader toggle={toggleErrorModal}>Error</ModalHeader>
				<ModalBody>{errorMessage}</ModalBody>
				<ModalFooter>
					<Button color="primary" onClick={toggleErrorModal}>
						Ok.
					</Button>
				</ModalFooter>
			</Modal>
		</>
	);
}

export const ResourceDetails = ({ ResourceStopJobs }) => {
	return (
		<Table>
			<thead>
				<tr>
					<th>Status</th>
					<th>Resource Name</th>
					<th>Stop time</th>
					<th></th>
				</tr>
			</thead>
			<tbody>
				{ResourceStopJobs.sort((a, b) =>
					a.name > b.name ? 1 : b.name > a.name ? -1 : 0
				).map((resource, index) => (
					<ResourceDetail resource={resource} key={index} />
				))}
			</tbody>
		</Table>
	);
};
